export default "__VITE_ASSET__BoVMkEn4__"